import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const update = async (data: {
  registerNo: undefined;
  lastName: undefined;
  firstName: undefined;
  email: undefined;
  phone: undefined;
  avatar: undefined;
}) => {
  const res = await httpRequest.post('/api/profile/update', data);
  return res;
};

export const get = async (id: string) => {
  const res = await httpRequest.get(`/api/car_model/${id}/detail`);
  return res;
};

export const password = async (data: { password: string; id: string }) => {
  const res = await httpRequest.put(`/api/user/${data.id}/password`, {
    password: data.password,
  });
  return res;
};

export const profilePassword = async (data: { password: string; oldPassword: string }) => {
  const res = await httpRequest.put(`/api/profile/password`, {
    oldPassword: data.oldPassword,
    password: data.password,
  });
  return res;
};
